export default "__VITE_ASSET__e3cbe43e__"